import { DecimalText, type DecimalTextProps } from 'components/text/decimal/DecimalText';

export function WeightText(props: DecimalTextProps) {
    return <DecimalText {...props} suffix="kg" />;
}
